<template>
  <i :class="`custom-icon bi bi-${iconName}`" :title="title" fill="currentColor" />
</template>

<script>
const iconRegex = /[^a-zA-Z0-9-]/;

export default {
  name: 'CustomIcon',

  props: {
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    iconName() {
      return this.icon == null ? 'blank' : this.icon.replace(iconRegex, '');
    },
  },
};
</script>

<style scoped>
.custom-icon {
  display: block;
  width: 1em;
  height: 1em;
  border-radius: unset;
}

.custom-icon.bi::before {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/IconSelector/CustomIcon.vue